import Brace from "backbone.brace";
import DiagCode from "./diag-code";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    chartReviewId: Number,
    fromDateOfService: String,
    throughDateOfService: String,
    disposition: String,
    auxType: String,
    statusValue: String,
    // used to decide whether to show the chooser button for MatchPoint claim selection.
    matchesFound: Boolean,
    canEdit: Boolean,
    canVoid: Boolean,

    // leave these as a raw Objects so they can be serializied and PUT
    // back to the API untouched. See extension, drg-adds-edit-form for their UI
    // implementation
    statusReasons: Object,
    users: Object,
    notes: Object,

    supplementalReasonCode: String,
    sourceReferenceNumber: String,
    providerReferenceNumber: String,
    assessmentId: String,
    diagRenderingProviderName: String,
    diagRenderingProviderNpi: String,
    mappedHCCs: String,
    clientClaimNbr: String,
    clientClaimMemberId: Number,
    clientClaimFromDateOfService: String,
    clientClaimThroughDateOfService: String,
    clientClaimProviderId: Number,
    clientCommercialPlanId: String,
    diagnosisCode: DiagCode,
    placeOfServiceCode: String,
    providerTypeCode: String,
    diagnosisAttributes: [Number],
    cmRunSid: Number,
    auditFileSid: Number,
    auditSid: Number,
    actorCode: String,
    auditClaimNbr: String,
    auditCommercialPlanId: String,
    auditClaimMemberId: String,
    auditClaimProviderId: String,
    auditClaimFromDateOfService: String,
    auditClaimThroughDateOfService: String,
    claimSelection: String,
    evaluationAction: String,
    matchPointClaimNbr: String,
    matchPointCommercialPlanId: String,
    matchPointClaimMemberId: Number,
    matchPointClaimProviderId: Number,
    matchPointClaimFromDateOfService: String,
    matchPointClaimThroughDateOfService: String,
    // if set, the DRG is associated with a MatchPoint claim
    cmMatchSid: Number,
  },

  stale: ["users", "notes", "matchesFound", "canEdit", "canVoid"],

  defaults: {
    id: null,
    chartReviewId: null,
    fromDateOfService: null,
    throughDateOfService: null,
    disposition: null,
    auxType: null,
    statusValue: null,
    matchesFound: null,
    canEdit: null,
    canVoid: null,
    statusReasons: null,
    users: null,
    notes: null,
    supplementalReasonCode: null,
    sourceReferenceNumber: null,
    providerReferenceNumber: null,
    assessmentId: null,
    diagRenderingProviderName: null,
    diagRenderingProviderNpi: null,
    mappedHCCs: null,
    clientClaimNbr: null,
    clientClaimMemberId: null,
    clientClaimFromDateOfService: null,
    clientClaimThroughDateOfService: null,
    clientClaimProviderId: null,
    clientCommercialPlanId: null,
    diagnosisCode: null,
    placeOfServiceCode: null,
    providerTypeCode: null,
    diagnosisAttributes: [],
    cmRunSid: null,
    auditFileSid: null,
    auditSid: null,
    actorCode: null,
    auditClaimNbr: null,
    auditCommercialPlanId: null,
    auditClaimMemberId: null,
    auditClaimProviderId: null,
    auditClaimFromDateOfService: null,
    auditClaimThroughDateOfService: null,
    claimSelection: null,
    evaluationAction: null,
    matchPointClaimNbr: null,
    matchPointCommercialPlanId: null,
    matchPointClaimMemberId: null,
    matchPointClaimProviderId: null,
    matchPointClaimFromDateOfService: null,
    matchPointClaimThroughDateOfService: null,
    cmMatchSid: null,
  },

  toJSON() {
    return _.omit(this.attributes, this.stale);
  },
});

export { Model as default };
